import React from 'react';
export function SolutionSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-345">
      <div className="max-w-4xl mx-auto text-center" data-id="element-346">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 border border-[#FFD700]/50 text-[#FFD700] font-bold text-sm px-5 py-2 rounded-full mb-8 tracking-wide" data-id="element-347">
          🏆 Sistema N°1 para Profesores de Batería en Argentina
        </div>

        <h2 className="text-4xl sm:text-5xl font-black text-white mb-4" data-id="element-348">
          🥁 PROFEPACK™
        </h2>
        <h3 className="text-2xl sm:text-3xl font-bold text-[#FFD700] mb-6" data-id="element-349">
          MEGAPACK BATERÍA LISTA
        </h3>
        <p className="text-white text-lg max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-350">
          <strong data-id="element-351">
            6 Tomos + 6 Bonos — Todos los niveles — Todo resuelto.
          </strong>
          <br data-id="element-352" />
          360 páginas de contenido técnico y pedagógico completo. Evaluaciones y
          rúbricas en cada tomo. Planificador anual listo para usar. Funciona
          desde hoy.
        </p>

        {/* Mockup visual */}
        <div className="relative mx-auto mb-10 max-w-2xl" data-id="element-353">
          <div className="grid grid-cols-6 gap-2 justify-center" data-id="element-354">
            {['#1565C0', '#2E7D32', '#E65100', '#6A1B9A', '#37474F', '#BF360C'].map((color, i) => {
            const labels = ['El Despegue', 'El Lenguaje', 'El Groove', 'La Técnica', 'La Banda', 'El Profe'];
            return <div key={i} className="aspect-[3/4] rounded-lg shadow-2xl flex items-end justify-center pb-2 px-1" style={{
              backgroundColor: color,
              border: '2px solid #FFD700'
            }} data-id="element-355">
                  <span className="text-white text-[10px] sm:text-xs font-bold text-center leading-tight" style={{
                textShadow: '0 1px 3px rgba(0,0,0,0.8)'
              }} data-id="element-356">
                    {labels[i]}
                  </span>
                </div>;
          })}
          </div>
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-[#FFD700] text-black font-black text-xs px-4 py-1 rounded-full whitespace-nowrap" data-id="element-357">
            6 TOMOS COMPLETOS
          </div>
        </div>

        {/* Pills */}
        <div className="flex flex-wrap items-center justify-center gap-3 mt-8" data-id="element-358">
          <span className="bg-[#FFD700]/10 border border-[#FFD700]/40 text-[#FFD700] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-359">
            ✅ Por nivel y etapa del año
          </span>
          <span className="bg-[#FFD700]/10 border border-[#FFD700]/40 text-[#FFD700] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-360">
            ✅ Con planificador anual listo
          </span>
          <span className="bg-[#FFD700]/10 border border-[#FFD700]/40 text-[#FFD700] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-361">
            ✅ Con sistema de evaluación completo
          </span>
          <span className="bg-[#FFD700]/10 border border-[#FFD700]/40 text-[#FFD700] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-362">
            ✅ Con rúbricas y fichas de seguimiento
          </span>
          <span className="bg-[#FFD700]/10 border border-[#FFD700]/40 text-[#FFD700] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-363">
            ✅ Con bonos incluidos
          </span>
          <span className="bg-[#FFD700]/10 border border-[#FFD700]/40 text-[#FFD700] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-364">
            ✅ Con canciones originales ProfePack® integradas
          </span>
        </div>
      </div>
    </section>;
}